<div class="wrapper">
  <!--  WEATHER  -->
  <app-consolidated-report-expandable-block
    (click)="handleExpansion('weather')"
    [isExpanded]="expandedSection === 'weather'"
    [subheading]="weatherList.length + ' item' + (weatherList.length === 1 ? '' : 's')"
    heading="Weather"
    icon="daily-report-weather"
    id="cpr-weather"
    >
    <ng-container>
      @if (weatherList && weatherList.length > 0) {
        <div (click)="$event.stopPropagation()"
          [class.collapsed]="!isWeathersPanelExpanded && weatherList.length > 3"
          class="panel weather-panel"
          >
          @for (weather of weatherList; track weather) {
            <app-consolidated-weather-summary-card
              (click)="triggerOpenDetailsPanel('weather', weather)"
              [data]="weather" />
          }
        </div>
        @if (weatherList?.length > 3) {
          <div
            (click)="isWeathersPanelExpanded = !isWeathersPanelExpanded; $event.stopPropagation()"
            class="see-more text-type-9 flex"
            >
            {{ isWeathersPanelExpanded ? 'See less' : 'See more' }}
          </div>
        }
      } @else {
        <div class="no-data">
          No weather data available.
        </div>
      }
    </ng-container>
  </app-consolidated-report-expandable-block>

  <hr class="divider" />

  <!--  BID ITEMS  -->
  <app-consolidated-report-expandable-block
    (click)="handleExpansion('bid-item')"
    [isExpanded]="expandedSection === 'bid-item'"
    [subheading]="bidItems?.length + ' item' + (bidItems?.length !== 1 ? 's' : '')"
    heading="Bid item"
    icon="daily-report-bid-item"
    id="cpr-bid-item"
    >
    <ng-container>
      @if (bidItems && bidItems?.length > 0) {
        <div (click)="$event.stopPropagation()" class="bid-items-panel">
          <app-bid-items-expandable-row-table [data]="bidItems" />
        </div>
      } @else {
        <div class="no-data">
          No bid item data available.
        </div>
      }
    </ng-container>
  </app-consolidated-report-expandable-block>

  <hr class="divider" />

  <app-consolidated-report-expandable-block
    (click)="handleExpansion('material-delivery')"
    [isExpanded]="expandedSection === 'material-delivery'"
    [subheading]="materialDeliveryCount + ' item' + (materialDeliveryCount === 1 ? '' : 's')"
    heading="Material delivery"
    icon="daily-report-material-delivery"
    id="cpr-material-delivery"
    >
    @if (materialDeliveryCount > 0) {
      <mat-tab-group
        #tabGroup
        (click)="$event.stopPropagation()"
        class="contents-tab-group"
        >
        <mat-tab
          [label]="materialDelivery?.delivery?.count + ' Deliver' + (materialDelivery?.delivery?.count === 1 ? 'y' :
          'ies')"
          >
          @if (materialDelivery?.delivery?.count) {
            <div class="panel delivery-panel">
              <!--   ADD MATERIAL DELIVERY COMPONENT AND LOOP IT     -->
            </div>
          } @else {
            <div class="no-data">
              No delivery available.
            </div>
          }
        </mat-tab>
        <mat-tab
          [label]="materialDelivery?.usage?.length + ' Usage' + (materialDelivery?.usage?.length === 1 ? '' :
          's')"
          >
          @if (materialDelivery?.usage?.length) {
            <div class="panel usage-panel">
              <!--   ADD MATERIAL USAGE COMPONENT AND LOOP IT     -->
            </div>
          } @else {
            <div class="no-data">
              No usage available.
            </div>
          }
        </mat-tab>
      </mat-tab-group>
    } @else {
      <div class="no-data">
        No material delivery available.
      </div>
    }
  </app-consolidated-report-expandable-block>

  <hr class="divider" />

  <app-consolidated-report-expandable-block
    (click)="handleExpansion('material-testing')"
    [isExpanded]="expandedSection === 'material-testing'"
    [subheading]="materialTestingCount + ' items'"
    heading="Material testing"
    icon="daily-report-material-testing"
    id="cpr-material-testing"
    >

    @if (materialTestingCount > 0) {
      <mat-tab-group
        #tabGroup
        (click)="$event.stopPropagation()"
        class="contents-tab-group"
        >
        <mat-tab label="Onsite">
          @if (materialTesting?.internal?.length) {
            <div (click)="$event.stopPropagation()" class="panel internal-panel">
              <!--   ADD MATERIAL TESTING INTERNAL COMPONENT AND LOOP IT     -->
            </div>
          } @else {
            <div class="no-data">
              No onsite tests available.
            </div>
          }
        </mat-tab>
        <mat-tab label="Offsite"
          >
          @if (materialTesting?.external?.length) {
            <div (click)="$event.stopPropagation()" class="panel external-panel">
              <!--   ADD MATERIAL TESTING EXTERNAL COMPONENT AND LOOP IT     -->
            </div>
          } @else {
            <div class="no-data">
              No offsite tests available.
            </div>
          }
        </mat-tab>
      </mat-tab-group>
    } @else {
      <div class="no-data">
        No material testing data available.
      </div>
    }

  </app-consolidated-report-expandable-block>

  <hr class="divider" />

  <!--  ISSUES  -->
  <app-consolidated-report-expandable-block
    (click)="handleExpansion('issues')"
    [isExpanded]="expandedSection === 'issues'"
    [subheading]="openIssuesCount + ' Open,'+ ' ' + closedIssuesCount + ' Closed' "
    heading="Issues"
    icon="daily-report-issues"
    id="cpr-issues"
    >
    <ng-container>
      @if (issues && issues?.length > 0) {
        @if (openIssues?.length) {
          <div class="category-heading my-[20px] text-type-6">
            Open :
          </div>
          <div
            (click)="$event.stopPropagation()"
            [class.collapsed]="!isOpenIssuesPanelExpanded && openIssues?.length > 4"
            class="panel open-issues-panel"
            >
            @for (issue of openIssues; track issue) {
              <div>
                <app-consolidated-report-issues-summary-card
                  (click)="triggerOpenDetailsPanel('issue', issue);$event.stopPropagation()"
                  [class.selected]="issue.id === selectedId"
                  [issue]="issue"
                  />
              </div>
            }
          </div>
          @if (openIssues?.length > 4) {
            <div
              (click)="isOpenIssuesPanelExpanded = !isOpenIssuesPanelExpanded"
              class="see-more text-type-9 flex"
              >
              {{ isOpenIssuesPanelExpanded ? 'See less' : 'See more' }}
            </div>
          }
        }
        @if (closedIssues?.length) {
          <div class="category-heading my-[20px] text-type-6">
            Closed :
          </div>
          <div (click)="$event.stopPropagation()"
            [class.collapsed]="!isClosedIssuesPanelExpanded && closedIssues?.length > 4"
            class="panel closed-issues-panel"
            >
            @for (issue of closedIssues; track issue) {
              <app-consolidated-report-issues-summary-card
                (click)="triggerOpenDetailsPanel('issue', issue);$event.stopPropagation()"
                [class.selected]="issue.id === selectedId"
                [issue]="issue"
                />
            }
          </div>
          @if (closedIssues?.length > 4) {
            <div
              (click)="isClosedIssuesPanelExpanded = !isClosedIssuesPanelExpanded; $event.stopPropagation()"
              class="see-more text-type-9 flex"
              >
              {{ isClosedIssuesPanelExpanded ? 'See less' : 'See more' }}
            </div>
          }
        }
      } @else {
        <div class="no-data">
          No issues data available.
        </div>
      }
    </ng-container>
  </app-consolidated-report-expandable-block>

  <hr class="divider" />

  <app-consolidated-report-expandable-block
    (click)="handleExpansion('labor-equipment')"
    [isExpanded]="expandedSection === 'labor-equipment'"
    heading="Labor & equipment"
    icon="daily-report-labor-equipment"
    id="cpr-labor-equipment"
    subheading="Labor & equipment subheading"
    >
    <ng-container>
      @if (laborEquipment.length) {
        <!--   ADD LABOR & EQUIPMENT COMPONENT AND LOOP IT     -->
      } @else {
        <div class="no-data">
          No labor equipment data available.
        </div>
      }
    </ng-container>
  </app-consolidated-report-expandable-block>

  <hr class="divider" />

  <app-consolidated-report-expandable-block
    (click)="handleExpansion('activities')"
    [isExpanded]="expandedSection === 'activities'"
    [subheading]="activities?.length + (activities?.length !== 1 ? ' entries' : ' entry')"
    heading="Activities"
    icon="daily-report-activity"
    id="cpr-activities"
    >
    <ng-container>
      @if (activities && activities.length > 0) {
        <div (click)="$event.stopPropagation()"
          [class.collapsed]="!isActivitiesPanelExpanded && activities.length > 3"
          class="panel activity-panel"
          >
          @for (activity of activities; track activity) {
            <app-consolidated-report-activity-summary-card
              (click)="triggerOpenDetailsPanel('activity', activity)"
              [class.selected]="activity.id === selectedId"
              [data]="activity" />
          }
        </div>
        @if (activities?.length > 3) {
          <div
            (click)="isActivitiesPanelExpanded = !isActivitiesPanelExpanded; $event.stopPropagation()"
            class="see-more text-type-9 flex"
            >
            {{ isActivitiesPanelExpanded ? 'See less' : 'See more' }}
          </div>
        }
      } @else {
        <div class="no-data">
          No activities data available.
        </div>
      }
    </ng-container>
  </app-consolidated-report-expandable-block>

</div>
